module.exports = __webpack_public_path__ + "img/icon_success.c6433e17.png";